export default __webpack_public_path__ + "static/media/four.6c52e8c4.jpeg";